import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/token'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authority'] = getToken()
    }
    if (config.url.indexOf('/user') === 0) {
      config.baseURL = process.env.VUE_APP_USER_API;
    }
    if (config.url.indexOf('/soft') > 0) {
      config.baseURL = process.env.VUE_APP_SOFTWARE_API;
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 200, it is judged as an error.
    if (res.extra && res.extra.code !== 200) {
      if (res.extra.code === 609) {
        removeToken()
      }
      Message({
        message: res.extra.msg || '出错啦，请稍后访问',
        type: 'error',
        duration: 5 * 1000
      })
      if ((res.extra.code === 401 || res.extra.code === 609) && window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
      return Promise.reject(new Error(res.extra.msg || 'Error'))
    } else {
      // console.log(response)
      if (response.config.method === 'post' || response.config.method === 'put' || response.config.method === 'delete') {
        if (response.config.tips !== 0) {
          // setTimeout用来修复element ui的模态框dialog关闭时会影响Message的位置的bug
          setTimeout(function() {
            Message({
              message: '操作成功',
              type: 'success',
              showClose: true,
              duration: 2 * 1000
            })
          }, 300)
        }
      }
      return res
    }
  },
  error => {
    console.log(error)
    let msg = error.message
    let code
    if (error.response) {
      code = error.response.status
    }
    if (error.response && error.response.data && error.response.data.extra) {
      msg = error.response.data.extra.msg
    }
    if (code === 401) {
      msg = '身份验证失败，请重新登录'
      removeToken()
    } else if (code === 609) {
      msg = '登陆过期，请重新登录'
      removeToken()
    } else if (code === 500) {
      msg = '出错啦，请稍后访问'
    }
    if (msg.indexOf('timeout') !== -1 && msg.indexOf('exceeded') !== -1) {
      msg = '你的网络不好，请检查网络'
    }
    Message({
      message: msg,
      type: 'error',
      showClose: true,
      duration: 5 * 1000
    })
    if ((code === 401 || code === 609) && window.location.pathname !== '/login') {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default service
